import React from 'react';
import { SharedModals } from './types';
export const SharedModalsMap = {
    [SharedModals.MODAL]: React.lazy(async () => ({
        default: (await import('./GenericModals')).EmptyModal,
    })),
    [SharedModals.LOADER_MODAL]: React.lazy(async () => ({
        default: (await import('./LoaderModal')).LoaderModal,
    })),
    [SharedModals.UPGRADE_PURCHASE_INTENT]: React.lazy(async () => ({
        default: (await import('./GetPremiumModal')).GetPremiumModal,
    })),
    [SharedModals.UPGRADE_CONNECT_INTENT]: React.lazy(async () => ({
        default: (await import('./UpgradeFreeSiteModal')).UpgradeFreeSiteModal,
    })),
    [SharedModals.CREATE_SITE_CONNECT_INTENT]: React.lazy(async () => ({
        default: (await import('./CreateSiteModal')).CreateSiteModalConnectIntent,
    })),
    [SharedModals.CREATE_SITE_PURCHASE_INTENT]: React.lazy(async () => ({
        default: (await import('./CreateSiteModal')).CreateSiteModalPurchaseIntent,
    })),
    [SharedModals.CONNECT_DOMAIN_DISABLED]: React.lazy(async () => ({
        default: (await import('./ConnectDomainDisabled'))
            .ConnectDomainDisabledModal,
    })),
    [SharedModals.TRANSFER_RECOMMEND_MODAL]: React.lazy(async () => ({
        default: (await import('./TransferRecommendModal')).TransferRecommendModal,
    })),
    [SharedModals.SITE_SELECTOR_MODAL]: React.lazy(async () => ({
        default: (await import('./SiteSelectorModal')).SiteSelectorModal,
    })),
    [SharedModals.GENERIC_MESSAGE_MODAL]: React.lazy(async () => ({
        default: (await import('./GenericMessageModal')).GenericMessageModal,
    })),
    [SharedModals.CHECKOUT_MODAL]: React.lazy(async () => ({
        default: (await import('./CheckoutModal')).CheckoutModal,
    })),
    [SharedModals.GENERIC_TECHNICAL_ERROR_MODAL]: React.lazy(async () => ({
        default: (await import('./GenericModals')).GenericTechnicalErrorModal,
    })),
    [SharedModals.AVAILABLE_EXTENSIONS_MODAL]: React.lazy(async () => ({
        default: (await import('./AvailableExtensionsModal'))
            .AvailableExtensionsModal,
    })),
};
//# sourceMappingURL=SharedModalsMap.js.map